class PushNotificationWeb {
  static async configure() {
    console.warn("Fix me! PushNotificationWeb");
  };
};

export default PushNotificationWeb
